import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/layoutActions";
import * as beads from "../../../actions/beadActions";
import redirector from "../../../util/redirector";

import FinancieringForm from "./FinancieringForm";
import FinancieringPageHelper from "./FinancieringPageHelper";
import ConfirmModal from "../../common/ConfirmModal";

class FinancieringPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.pageHelper = new FinancieringPageHelper(this, redirector);
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    componentWillUnmount() {
        this.pageHelper.handleOnStopInterval();
    }

    handleOnDeleteFinancier(event, id) {
        this.pageHelper.deleteFinancier(id);
    }

    handleOnShowDeleteModal(event, id) {
        window.parent.scrollTo(0, 450);
        this.pageHelper.openModal(id);
    }

    handleOnGenerateRapport() {
        this.pageHelper.generateRapport();
    }

    handleOnEditFinancier() {
        this.pageHelper.editFinancier();
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        return (<div>
            <ConfirmModal
                hookToTop
                isOpen={this.state.modalIsOpen}
                mainText="Ben je zeker dat je deze financier wil verwijderen?"
                confirmAction={() => this.pageHelper.deleteFinancier()}
                cancelAction={() => this.pageHelper.closeModal()}
                confirmText="Verwijder"
                cancelText="Annuleer" />
            <FinancieringForm
                color={types.COLOR_PINK_LIGHT}
                model={this.state.financiering}
                okiTypes={this.props.okiTypes}
                goToFinancierEdit={() => this.pageHelper.goToFinancierEdit()}
                handleOnEditFinancier={(dossierId, financierId) => this.pageHelper.handleOnEditFinancier(dossierId, financierId)}
                getFile={this.pageHelper.getFile}
                showDeleteModal={this.handleOnShowDeleteModal}
                documenten={this.state.documenten}
                getFileUrl={this.pageHelper.getFileUrl}
                generateRapport={this.handleOnGenerateRapport}
                isPollingDocument={this.state.timer ? true : false}
            />
        </div>);
    }
}
FinancieringPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;

    return {
        dossierId: dossierId,
        okiTypes: state.referentie.typeOpbrengstKostInvesteringen
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadFinancieelPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(FinancieringPage));